import * as Diff from 'diff';
import { ThinkingStep, YAMLFix, CloudFix } from '@/api/websocket';

// Shared Message interface for all chat components
export interface ChatMessage {
  id: string;
  text: string;
  sender: 'user' | 'bot';
  timestamp: number;
  isStreaming?: boolean;
  attachments?: Array<{ type: string; name: string }>;
  thinking?: {
    text: string;
    steps: ThinkingStep[];
    isExpanded: boolean;
  };
  yamlFixes?: YAMLFix[];
  cloudFixes?: CloudFix[];
}

// Diff line type
export interface DiffLine {
  line: string;
  type: 'unchanged' | 'removed' | 'added';
  lineNumber?: number;
}

// Create GitHub-style diff using Myers algorithm
export const createDiff = (oldText: string, newText: string): DiffLine[] => {
  const changes = Diff.diffLines(oldText, newText);
  const result: DiffLine[] = [];

  let oldLineNumber = 1;
  let newLineNumber = 1;

  changes.forEach(change => {
    const lines = change.value.split('\n');
    // Remove the last empty line if it exists (common with diffLines)
    if (lines[lines.length - 1] === '') {
      lines.pop();
    }

    lines.forEach(line => {
      if (change.removed) {
        result.push({
          line,
          type: 'removed',
          lineNumber: oldLineNumber++
        });
      } else if (change.added) {
        result.push({
          line,
          type: 'added',
          lineNumber: newLineNumber++
        });
      } else {
        result.push({
          line,
          type: 'unchanged',
          lineNumber: oldLineNumber
        });
        oldLineNumber++;
        newLineNumber++;
      }
    });
  });

  return result;
};
